import { applyMiddleware, compose, createStore } from "redux";
import { routerMiddleware } from "connected-react-router";
import createRootReducer from "./reducers";
import thunk from "redux-thunk";

export let history = null;

export const setHistory = (past) => (history = past); // for testing only

export default function configureStore(appHistory) {
  history = appHistory;
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const preloadedState = composeEnhancers(applyMiddleware(routerMiddleware(history), thunk));
  const store = createStore(createRootReducer(history), preloadedState);
  return store;
}
